export const CarsConstatns = {
  MANUFACTURER: 'manufacturer',
  MODEL_SERIES: 'modelSeries',
  FUEL_TYPE: 'fuelType',
  GEARBOX_TYPE: 'gearboxType',
  BRANCH: 'branch',
  COLOR: 'color',
  ENVIRONMENT_CLASS: 'environmentClass',
  SEGMENT: 'properties.segment',
  DRIVING_WHEEL: 'drivingWheel',
  PRICE: 'price',
  MILEAGE: 'mileage',
  ODOMETER_VALUE_AS_KM: 'odometerValueAsKm',
  MODEL_YEAR: 'modelYear',
  LEASING_PRICE: 'leasingPrice',
};

export const ContentConstants = {
  PAGE_TYPE: 'page_type',
};
